
import SegundaChamadaService from "@/service/v10/sigap/SegundaChamadaService"
import Multiselect from '@vueform/multiselect'
import BotaoSalvar from '@/components/aplicacao/BotaoSalvar.vue';
import { Options, Vue } from "vue-class-component";
import SiteUtils from '@/assets/ts/aplicacao/site';
import $ from "jquery"
import { Prop } from 'vue-property-decorator';

@Options({
    name: "ProfileSegundaChamadaCadastro",
    components: { Multiselect, BotaoSalvar },
    emits: ['segunda-chamada-criada'],
})
export default class ProfileSegundaChamadaCadastro extends Vue {
    
    @Prop() readonly modal!: any
    @Prop() readonly matricula!: any
    @Prop() readonly disciplinas!: any
    @Prop() readonly status!: any

    public service = new SegundaChamadaService();
    public processando = false;
    public titulo = 'Cadastrar Segunda Chamada';

    public disciplinaId: any = null;
    public dataAvaliacao: any = null;
    public dataSolicitacao: any = null;
    public justificativa: any = null; 
    public statusId: any = null;

    get disciplinas_select() {
        if (!this.disciplinas) { return null; }
        return this.disciplinas.map((item) => {
            return { value: item.id, label: item.descricao }
        });
    }

    get status_select() {
        if (!this.status) { return null; }
        return this.status.map((item) => { return { value: item.id, label: item.nome } });
    }

    public getdados() {
        const dados: any = {};
        dados.matriculaId = this.matricula.id;
        dados.disciplinaId = this.disciplinaId;
        dados.dataAvaliacao = this.dataAvaliacao;
        dados.dataSolicitacao = this.dataSolicitacao;
        dados.justificativa = this.justificativa; 
        dados.status = this.statusId;
        return dados;
    }

    public sucesso() {
        this.$emit("segunda-chamada-criada", null);
        this.disciplinaId = null;
        this.dataAvaliacao = null;
        this.dataSolicitacao = null;
        this.justificativa = null; 
        this.statusId = null;
        $("[data-bs-dismiss='modal']").trigger({ type: "click" });
    }

    public salvar() {
        if (this.processando) {
            return;
        }
        if (!this.disciplinaId || !this.dataAvaliacao || !this.dataSolicitacao || !this.justificativa ) {
            SiteUtils.toastErro('Error!', 'Preencha os campos obrigatorios.');
            return;
        }
        this.processando = true;
        const dados = this.getdados();
        setTimeout(() => {
            this.service.cadastrar(dados)
                .then(response => {
                    SiteUtils.toastSucesso('Cadastrado com sucesso!', response.message);
                    this.sucesso();
                    this.processando = false;
                })
                .catch(error => {
                    this.processando = false;
                    SiteUtils.toastErro('Error!', error.data.message);
                });
        }, 100);
    }
}
